import loadable from "@loadable/component";
import LinearProgress from "@material-ui/core/LinearProgress";

/**
 * Dynamically loaded version of `AdminLogsPage`.
 */
const LoadablePage = loadable(
  () => import(/* webpackChunkName: "AdminLogsPage" */ "."),
  {
    fallback: <LinearProgress />,
  }
);

export default LoadablePage;
